import React from "react";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import CustomTooltip from "../Tooltip";

const Index = ({ loading, title, ...other }) => {
  const { t } = useTranslation(["configure"]);

  return (
    <CustomTooltip title={title || t("Refresh")}>
      <Button type="primary" color="primary" style={{ padding: 5 }} {...other}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.27586 16C5.96552 16 4.00862 15.225 2.40517 13.675C0.801724 12.125 0 10.2333 0 8C0 5.76667 0.801724 3.875 2.40517 2.325C4.00862 0.775 5.96552 0 8.27586 0C9.46552 0 10.6034 0.237333 11.6897 0.712C12.7759 1.18667 13.7069 1.866 14.4828 2.75V0H16.5517V7H9.31034V5H13.6552C13.1034 4.06667 12.349 3.33333 11.3917 2.8C10.4345 2.26667 9.39586 2 8.27586 2C6.55172 2 5.08621 2.58333 3.87931 3.75C2.67241 4.91667 2.06897 6.33333 2.06897 8C2.06897 9.66667 2.67241 11.0833 3.87931 12.25C5.08621 13.4167 6.55172 14 8.27586 14C9.60345 14 10.8017 13.6333 11.8707 12.9C12.9397 12.1667 13.6897 11.2 14.1207 10H16.2931C15.8103 11.7667 14.8276 13.2083 13.3448 14.325C11.8621 15.4417 10.1724 16 8.27586 16Z"
            fill="white"
          />
        </svg>
      </Button>
    </CustomTooltip>
  );
};

export default Index;
